import type { MfDate, MfDateRange } from '@campaign-manager/core/model';

import { DateValueString } from '../DateValue';

interface Props {
  range?: MfDateRange;
  start?: MfDate | Date | string | undefined;
  end?: MfDate | Date | string | undefined;
}

export default function DateRangeValue(props: Props) {
  return <>{DateRangeValueString(props)}</>;
}

export function DateRangeValueString({ range, start, end }: Props) {
  if (range) return dateRange(range.start, range.end);

  if (!start) return null;

  if (end) {
    return dateRange(start, end);
  }

  return DateValueString({ date: start });
}

function dateRange(start: Props['start'], end: Props['end']) {
  return `${DateValueString({ date: start })}–${DateValueString({
    date: end,
  })}`;
}
